<template lang="pug">
  div
    order-processing-top(:company="company")
    order-calendar-filters-chip(:company="company" :parentDateSelectionMode.sync="dateSelectionMode")
    v-container.pa-0(style="max-width: 600px")
      calendar-picker(:parentDates.sync="dates" :company="company" :dateSelectionMode="dateSelectionMode")
      div
        v-divider.basic300
        div.py-3.px-4.d-flex.align-center(v-if="!isFetching")
          bulk-order-actions(:leads="leads")
          y-pagination(v-model="page" :pageSize="fetchCount" :count="totalCount")
      v-layout.my-6.px-2.pt-2(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .content-layout(v-else)
        v-layout.my-6.px-2.pt-2(v-if="leads.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/order_mgmt_empty.png')" style="width:80px; height:80px" contain)
              div.p2.basic600--text.text-center {{ $t('no_orders_found') }}
              div.p2.basic600--text.text-center {{ $t('no_orders_adjust_filter') }}
        div(v-else)
          v-divider.basic300
          div(v-for="leadDate in leadDateList" :key="leadDate.id")
            template(v-if="leadDateList.length > 1")
              div(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`")
                div.s2.primary400--text.px-4.py-1 {{ leadDate.date | humanizeDateLong }}
              template(v-for="lead in leadDate.leads")
                order-item(:parentLead.sync="lead" :menu="menu" @deleted="handleDeletedItem($event)")
                v-divider.basic300
            template(v-else v-for="lead in leadDate.leads")
              order-item(:parentLead.sync="lead" :menu="menu" @deleted="handleDeletedItem($event)")
              v-divider.basic300
        div.py-3.px-4
          y-pagination-custom(v-if="leads.length > 0" v-model="page" :parentPageSize.sync="fetchCount" :count="totalCount" :text="'Show orders'")
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import queryString from 'query-string'
import OrderProcessingTop from '@/components/ordermgmt/OrderProcessingTop.vue'
import CalendarPicker from '@/components/ordermgmt/CalendarPicker.vue'
import OrderItem from '@/components/ordermgmt/OrderItem.vue'
import OrderCalendarFiltersChip from '@/components/ordermgmt/OrderCalendarFiltersChip.vue'
import BulkOrderActions from '@/components/ordermgmt/BulkOrderActions'

export default {
  name: 'OrderCalendarView',
  components: { OrderProcessingTop, CalendarPicker, OrderItem, OrderCalendarFiltersChip, BulkOrderActions },
  props: ['company', 'menu'],
  data: vm => ({
    isFetching: false,
    searchCountDown: null,
    page: 1,
    fetchCount: 20,
    totalCount: vm.$store.state.ui.pendingOrderCount,
    leads: [],
    checkAll: false,
    dateSelectionMode: 'single',
    dates: null
  }),
  computed: {
    ...mapState('user', ['user', 'member']),
    ...mapGetters({
      view: 'orders/getOrderView',
      filters: 'orders/getFilters',
      search: 'orders/getSearch',
      orderTempData: 'tours/getOrderTempData'
    }),
    leadDateList() {
      let dates = this.leads.map(m => m.processed_at.substr(0, 10))
      let uniqueDates = [...new Set(dates)]
      return uniqueDates.map(m => {
        return { date: m, leads: this.leads.filter(f => f.processed_at.substr(0, 10) === m) }
      })
    }
  },
  watch: {
    page(val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchLeads(val)
      }
    },
    fetchCount() {
      this.page = 1
      this.fetchLeads(1)
    },
    search() {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.fetchLeads(1)
      }, 500)
    },
    filters: {
      deep: true,
      handler() {
        this.fetchLeads(1)
      }
    },
    '$store.state.orders.leadsVersion'() {
      this.fetchLeads(1)
    },
    dates: {
      deep: true,
      handler(val) {
        if (val) {
          if (this.dateSelectionMode === 'range') {
            if (val.length > 1) {
              this.fetchLeads(1)
            }
          } else {
            if (this.searchCountDown) {
              clearTimeout(this.searchCountDown)
            }
            this.searchCountDown = setTimeout(() => {
              this.fetchLeads(1)
            }, 500)
          }
        }
      }
    }
  },
  mounted() {
    this.fullscreen = window.innerWidth < 600
    // this.fetchZones()
    if (!this.$route.query.page) {
      this.fetchLeads(1)
    } else {
      this.fetchLeads(this.$route.query.page)
    }
    setTimeout(() => {
      this.orderTourCheck()
    }, 2000)
  },
  methods: {
    fetchLeads(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let params = new URLSearchParams()
      params.append('page', page)
      params.append('page_size', this.fetchCount)
      params.append('form__company', this.company.id)
      params.append('form_type_exclude', 'book_income')
      params.append('status', 'processed')
      if (this.search && this.search.length >= 2 && this.search.includes('#')) {
        params.append('rid', this.search.replace('#', ''))
      } else if (this.search) {
        params.append('search', this.search)
      }
      if (this.member.role !== 'Admin') {
        params.append('member', this.member.id)
      }
      if (this.dates) {
        if (this.filters.date === 'scheduled') {
          if (this.dateSelectionMode === 'range') {
            if (this.dates.length === 1) {
              params.append('asking_delivery_date_after', this.dates[0])
              params.append('asking_delivery_date_before', this.dates[0])
            } else {
              if (this.dates[0] < this.dates[1]) {
                params.append('asking_delivery_date_after', this.dates[0])
                params.append('asking_delivery_date_before', this.dates[1])
              } else {
                params.append('asking_delivery_date_after', this.dates[1])
                params.append('asking_delivery_date_before', this.dates[0])
              }
            }
          } else if (this.dateSelectionMode === 'multiple') {
            if (this.dates.length > 0) {
              params.append('asking_delivery_date_dates', this.dates.toString())
            }
          } else {
            params.append('asking_delivery_date_dates', this.dates)
          }
        } else {
          if (this.dateSelectionMode === 'range') {
            if (this.dates.length === 1) {
              params.append('processed_at_after', this.dates[0])
              params.append('processed_at_before', this.dates[0])
            } else {
              if (this.dates[0] < this.dates[1]) {
                params.append('processed_at_after', this.dates[0])
                params.append('processed_at_before', this.dates[1])
              } else {
                params.append('processed_at_after', this.dates[1])
                params.append('processed_at_before', this.dates[0])
              }
            }
          } else if (this.dateSelectionMode === 'multiple') {
            if (this.dates.length > 0) {
              params.append('processed_at_dates', this.dates.toString())
            }
          } else {
            params.append('processed_at_dates', this.dates)
          }
        }
      }
      if (this.filters.sort === 'oldest') {
        params.append('ordering', 'processed_at')
      } else {
        params.append('ordering', '-processed_at')
      }
      if (this.filters.processing || this.filters.ready) {
        let data = {
          processing: this.filters.processing || [],
          ready: this.filters.ready || []
        }
        params.append('order_management_status', JSON.stringify(data))
      }
      if (this.filters.shipping && Object.keys(this.filters.shipping).length > 0) {
        params.append('fulfilment_method', JSON.stringify(this.filters.shipping))
      }
      if (this.filters.payment && this.filters.payment.length > 0) {
        this.filters.payment.forEach(o => {
          params.append('payment_method', o.value)
        })
      }
      if (this.filters.source && this.filters.source.length > 0) {
        this.filters.source.forEach(o => {
          params.append('form', o.id)
        })
      }
      this.$axios
        .get('/leads/', { params: params })
        .then(response => {
          this.isFetching = false
          this.leads = response.data.results
          this.totalCount = response.data.count
        })
        .catch(() => {})
    },
    fetchOneLead(leadPid) {
      // Find and update one lead
      const index = this.leads.findIndex(lead => lead.pid === leadPid)
      if (index >= 0) {
        this.$axios
          .get(`/leads/${leadPid}`)
          .then(response => {
            this.leads.splice(index, 1, response.data)
          })
          .catch(() => {})
      }
    },
    handleDeletedItem(item) {
      this.totalCount = this.totalCount - 1
      this.leads = this.leads.filter(x => x.id !== item.id)
    },
    orderTourCheck() {
      if (this.orderTempData && (this.orderTempData.value === 'completed' || (this.orderTempData.extra_data && this.orderTempData.extra_data.calendarView))) {
        return
      }
      this.$store.commit('tours/setOrderManagementCalendarViewTour')
      this.$nextTick(() => {
        this.$tours['YezzaTour'].start()
      })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>